import segment from 'src/js/modules/analytics/segment';

const {
  constants,
  trackers: { trackEvent },
} = segment;

const trackElementSettingsDialogDisplayed = ({
  blockId,
  blockVariationId,
  settingsId,
  tabId,
  elementType,
  breakpointType,
}) => {
  if (!tabId || !blockId) return;

  trackEvent(constants.events.ELEMENT_SETTINGS_DIALOG_DISPLAYED, {
    blockId,
    blockVariationId,
    settingsId,
    tabId,
    elementId: elementType,
    breakpointType,
  });
};

export default trackElementSettingsDialogDisplayed;
